export default __webpack_public_path__ + "static/media/kia.2ca494b5.svg";